import { useCallback } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AdminRoute , EmployeeRoute } from "./components/guards";
import useInactivityLogout from "./hooks/useInactivityLogout";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import QRManager from "./components/QRManager";
import QRScanner from "./components/QRScanner";
//import EventManagement from "./components/EventManagement";
import EventManagement from "./components/EventMan";
import EventCreate from "./components/EventCreate";
import EventList from "./components/EventList";
import EventAnketoMan from "./components/EventAnketoMan";
// EventReduce は EventCreate に統合済み
import EventDepartmentConfirm from "./components/EventDepartmentConfirm";
import EventConfirmList from "./components/EventConfirmList";
import EventConfirmation from "./components/EventConfirmation";
import EventSummary from "./components/EventSummary";
import EventParticipants from "./components/EventParticipants";
import EventAbsentees from "./components/EventAbsentees";
import EventUnregistered from "./components/EventUnregistered";
import EventDetail from "./components/EventDetail";
import AnketoResults from "./components/EventAnketoResults";
import EventAnketoStatistics from "./components/EventAnketoStatistics";
import EventAnketoAIReport from "./components/EventAnketoAIReport";
import EmergencyContactManager from "./components/EmergencyContactManager";
//import EmergencyContactOrganization from "./components/EmergencyContactOrganization";
import OrganizationTree from "./components/OrganizationTree";
import OrgnizationDeptEmployee from "./components/OrganizationDeptEmployee";
import DepartmentEmployees from "./components/DepartmentEmployees"
import Application from "./components/Application";
import ApplicationDetail from "./components/ApplicationDetail";
import BCPAdmin from "./components/BCPAdmin";
import SalaryPage from './pages/SalaryPage'; 
//import Workstime from "./pages/Workstime";
import WorkTimes from './components/WorkTimes';
import EmployeeCardSetting from "./components/EmployeeCardSetting";
import NoticeCreate from "./components/NoticeCreate";
import NoticeReaders from "./components/NoticeReaders";
import AdminNotifications from "./components/AdminNotifications";
import StressCheck from "./components/StressCheck";
import LeaveAdminList from "./components/LeaveAdminList";
import WorktimeDailyAdmin from "./pages/WorktimeDailyAdmin";
import LaborHoursList from "./pages/LaborHoursList";
import LaborHoursAnalytics from "./pages/LaborHoursAnalytics";
import LaborHoursAIReport from "./pages/LaborHoursAIReport";
import AdminShiftBulkImport from "./pages/AdminShiftBulkImport";
import AdminShiftRosterImport from "./pages/AdminShiftRosterImport";
import AdminScheduleHub from "./pages/AdminScheduleHub";
import AdminEmployeeSchedule from "./pages/AdminEmployeeSchedule";
import DepartmentMasters from "./components/DepartmentMasters";
import CompanyMaster from "./components/CompanyMaster";
import FeatureHelpManager from "./components/FeatureHelpManager";
import LeaveInfoMaster from "./components/LeaveInfoMaster";
import ShiftMaster from "./components/ShiftMaster";
import WorkLocationMaster from "./components/WorkLocationMaster";
import AdminEmployeeMaster from "./components/AdminEmployeeMaster";
import DepartmentAndMapManager from "./components/DepartmentAndMapManager";
import IntroductionSetup from "./components/IntroductionSetup";
import PermissionManager from "./components/PermissionManager";
import ProjectMasterCreate from "./components/ProjectMasterCreate";
import ProjectPatternViewer from "./components/ProjectPatternViewer";
import AdminQuotes from "./components/AdminQuotes";

import MobileLogin from "./pages/MobileLogin";
import EmployeeCard from "./components/EmployeeCard";
import EmployeeBack from "./components/EmployeeBack";
import EmployeeEvents from './components/EmployeeEvents';
import Event from "./components/Event";
import ApplicationForms from "./components/ApplicationForm";
import SelectedForms from "./components/SelectedForms";
import ApplicationHistory from "./components/ApplicationHistory";
import BCPEmployee from "./components/BCPEmployee";
import BcpHomeShelter from "./components/BcpHomeShelter";
import BcpNearbyShelter from "./components/BcpNearbyShelter";
import BcpSearch from './components/BcpSearch';
import BcpWeatherInfo from "./components/BcpWeatherInfo";
import SupervisorOvertimeList from "./components/SupervisorOvertimeList";
import SupervisorForgotPunchList from "./components/SupervisorForgotPunchList";
import EmployeeEmergencyContact from "./components/EmployeeEmergencyContact";
import EmployeeStress from "./components/EmployeeStress";
import EmployeeTime from "./components/EmployeeTime";
import EmployeeTimeRecord from "./pages/EmployeeTimeRecord";
import EmployeeTimeAppplication from "./forms/TimeOverForm";
import EmployeeSchedule from "./pages/EmployeeSchedule";
import EmployeeSalaryPage from './pages/EmployeeSalaryPage'; 
import EmployeeNotice from "./components/EmployeeNotice";
import EmployeeLeaves from "./components/EmployeeLeaves";
import EventMenu from "./components/EventMenu";
import EventAnketo from "./components/EventAnketo";
import Login from "./pages/Login";
import IDCardPage from "./pages/IDCardPage";


// 本番は /employee　ローカルは /
const detectBase = () =>
  window.location.pathname.startsWith("/employee") ? "/employee" : "/";

function Placeholder({ title }) {
  return <div style={{ padding: 24 }}>{title}</div>;
}

function AppRoutes() {
  // 無操作サインアウト: 管理者は従来どおり30分、社員は24時間（端末の画面ロックに任せる運用）
  const isAdmin = typeof window !== "undefined" && !!localStorage.getItem("adminUser");
  const handleInactivityLogout = useCallback(() => {
    const wasAdmin = !!localStorage.getItem("adminUser");
    ["access", "refresh", "user", "adminUser"].forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
    window.location.href = wasAdmin ? "/admin/login" : "/m/login";
  }, []);
  useInactivityLogout(handleInactivityLogout, isAdmin ? 30 * 60 * 1000 : 24 * 60 * 60 * 1000);
  return (
    <Routes>
        {/* トップはモバイルログインへ */}
        <Route index element={<Navigate to="m/login" replace />} />

        {/* ログイン・社員証（社員番号ログイン → /id-card） */}
        <Route path="login" element={<Login />} />
        <Route path="id-card" element={<EmployeeRoute loginPath="/login"><IDCardPage /></EmployeeRoute>} />

        {/* モバイル側 */}
        <Route path="m/login" element={<MobileLogin />} />
        <Route path="card_front" element={<EmployeeRoute><EmployeeCard /></EmployeeRoute>} />
        <Route path="card_back" element={<EmployeeRoute><EmployeeBack /></EmployeeRoute>} />
        <Route path="events" element={<EmployeeRoute><EmployeeEvents /></EmployeeRoute>} />  
        <Route path="event/:eventId" element={<EmployeeRoute><Event /></EmployeeRoute>} />
        <Route path="event/:eventId/anketo" element={<EmployeeRoute><EventAnketo /></EmployeeRoute>} />
        <Route path="stress" element={<EmployeeRoute><EmployeeStress /></EmployeeRoute>} />
        <Route path="applications" element={<EmployeeRoute><ApplicationForms /></EmployeeRoute>} />
        <Route path="applications/history" element={<EmployeeRoute><ApplicationHistory /></EmployeeRoute>} />
        <Route path="selected-forms" element={<EmployeeRoute><SelectedForms /></EmployeeRoute>} />
        <Route path="bcp" element={<EmployeeRoute><BCPEmployee /></EmployeeRoute>} />
        <Route path="bcp/home-shelter" element={<EmployeeRoute><BcpHomeShelter /></EmployeeRoute>} />
        <Route path="bcp/nearby-shelter" element={<EmployeeRoute><BcpNearbyShelter /></EmployeeRoute>} />
        <Route path="bcp/search-address" element={<EmployeeRoute><BcpSearch /></EmployeeRoute>} />
        <Route path="bcp/weather-info" element={<EmployeeRoute><BcpWeatherInfo /></EmployeeRoute>} />
        <Route path="supervisor/overtime" element={<EmployeeRoute><SupervisorOvertimeList /></EmployeeRoute>} />
        <Route path="supervisor/forgot-punch" element={<EmployeeRoute><SupervisorForgotPunchList /></EmployeeRoute>} />
        <Route path="worktime" element={<EmployeeRoute><EmployeeTime /></EmployeeRoute>} />
        <Route path="worktime/record" element={<EmployeeRoute><EmployeeTimeRecord /></EmployeeRoute>} />
        <Route path="worktime/application" element={<EmployeeRoute><EmployeeTimeAppplication /></EmployeeRoute>} />
        <Route path="schedule" element={<EmployeeRoute><EmployeeSchedule /></EmployeeRoute>} />
        <Route path="emergency_contact" element={<EmployeeRoute><EmployeeEmergencyContact /></EmployeeRoute>} />
        <Route path="salary" element={<EmployeeRoute><EmployeeSalaryPage /></EmployeeRoute>} />
        <Route path="notice" element={<EmployeeRoute><EmployeeNotice /></EmployeeRoute>} />
        <Route path="leave" element={<EmployeeRoute><EmployeeLeaves /></EmployeeRoute>} />
        {/*　社員権限 */}
        <Route path="employee/event/create" element={<EmployeeRoute><EventCreate /></EmployeeRoute>} />
        <Route path="employee/event/list" element={<EmployeeRoute><EventList /></EmployeeRoute>} />
        <Route path="employee/notice" element={<EmployeeRoute><NoticeCreate /></EmployeeRoute>} />
        <Route path="employee/applications" element={<EmployeeRoute><Application /></EmployeeRoute>} />
        <Route path="employee/notice" element={<EmployeeRoute><NoticeCreate /></EmployeeRoute>} />


        {/* 管理側 */}
        <Route path="admin/login" element={<AdminLogin />} />
        <Route path="dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="admin" element={<Placeholder title="OK: admin" />} />
        <Route path="admin/qr" element={<AdminRoute><QRManager /></AdminRoute>} />
        <Route path="admin/qr-scan" element={<AdminRoute><QRScanner /></AdminRoute>} />
        {/*<Route path="admin/create_event" element={<AdminRoute><EventManagement /></AdminRoute>} />*/}
        <Route path="admin/create_event" element={<AdminRoute><EventMenu /></AdminRoute>} />
        <Route path="event/create" element={<AdminRoute><EventCreate /></AdminRoute>} />
        <Route path="event/list" element={<AdminRoute><EventList /></AdminRoute>} />
        <Route path="event/anketo" element={<AdminRoute><EventAnketoMan /></AdminRoute>} />
        <Route path="event/reduce/:eventId" element={<AdminRoute><EventCreate /></AdminRoute>} />
        <Route path="event/department/confirm/:eventId" element={<AdminRoute><EventDepartmentConfirm/></AdminRoute>} />
        <Route path="event/confirm-list/:eventId" element={<AdminRoute><EventConfirmList/></AdminRoute>} />
        <Route path="event/confirmation/:eventId" element={<AdminRoute><EventConfirmation/></AdminRoute>} />
        <Route path="event/summary/:eventId" element={<AdminRoute><EventSummary/></AdminRoute>} />
        <Route path="event/participants/:eventId" element={<AdminRoute><EventParticipants /></AdminRoute>} />
        <Route path="event/absentees/:eventId" element={<AdminRoute><EventAbsentees /></AdminRoute>} />
        <Route path="event/unregistered/:eventId" element={<AdminRoute><EventUnregistered /></AdminRoute>} />
        <Route path="admin/eventDetail" element={<AdminRoute><EventDetail/></AdminRoute>} />
        <Route path="event/:eventId/get_responses" element={<AdminRoute><AnketoResults /></AdminRoute>} />
        <Route path="event/:eventId/statistics" element={<AdminRoute><EventAnketoStatistics /></AdminRoute>} />
        <Route path="event/:eventId/ai-report" element={<AdminRoute><EventAnketoAIReport /></AdminRoute>} />
        <Route path="admin/stress" element={<AdminRoute><StressCheck/></AdminRoute>} />
        <Route path="admin/applications" element={<AdminRoute><Application /></AdminRoute>} />
        <Route path="admin/applications/:id" element={<AdminRoute><ApplicationDetail /></AdminRoute>} />
        <Route path="admin/salary" element={<AdminRoute><SalaryPage /></AdminRoute>} />
        <Route path="admin/bcp" element={<AdminRoute><BCPAdmin /></AdminRoute>} />
        <Route path="admin/workstime" element={<AdminRoute><WorkTimes/></AdminRoute>} />
        <Route path="admin/worktime-daily" element={<AdminRoute><WorktimeDailyAdmin /></AdminRoute>} />
        <Route path="admin/labor-hours-list" element={<AdminRoute><LaborHoursList /></AdminRoute>} />
        <Route path="admin/labor-hours-analytics" element={<AdminRoute><LaborHoursAnalytics /></AdminRoute>} />
        <Route path="admin/labor-hours/analytics" element={<AdminRoute><LaborHoursAIReport /></AdminRoute>} />
        <Route path="admin/shift-bulk-import" element={<AdminRoute><AdminShiftBulkImport /></AdminRoute>} />
        <Route path="admin/shift-roster-import" element={<AdminRoute><AdminShiftRosterImport /></AdminRoute>} />
        <Route path="admin/workstime/schedule" element={<AdminRoute><AdminScheduleHub /></AdminRoute>} />
        <Route path="admin/employee-schedule/:memberId" element={<AdminRoute><AdminEmployeeSchedule /></AdminRoute>} />
        {/*<Route path="admin/emergency_contact" element={<AdminRoute><EmergencyContactManager /></AdminRoute>} />*/}
        <Route path="admin/emergency_contact" element={<AdminRoute><OrganizationTree /></AdminRoute>} />
        <Route path="admin/employee-manager" element={<AdminRoute><OrgnizationDeptEmployee /></AdminRoute>} />        
        <Route path="departments/:id/employees" element={<AdminRoute><DepartmentEmployees /></AdminRoute>} />
        <Route path="admin/feature-help" element={<AdminRoute><FeatureHelpManager /></AdminRoute>} />
        <Route path="/admin/employee-card-setting" element={<AdminRoute><EmployeeCardSetting /></AdminRoute>} />
        <Route path="admin/notice" element={<AdminRoute><NoticeCreate /></AdminRoute>} />
        <Route path="admin/notice/:noticeId/readers" element={<AdminRoute><NoticeReaders /></AdminRoute>} />
        <Route path="admin/notifications" element={<AdminRoute><AdminNotifications /></AdminRoute>} />
        <Route path="admin/leave" element={<AdminRoute><LeaveAdminList /></AdminRoute>} />
        <Route path="departments" element={<AdminRoute><DepartmentAndMapManager /></AdminRoute>} />
        <Route path="company-config" element={<AdminRoute><CompanyMaster /></AdminRoute>} />
        <Route path="paidLeave" element={<AdminRoute><LeaveInfoMaster /></AdminRoute>} />
        <Route path="shifts" element={<AdminRoute><ShiftMaster /></AdminRoute>} />
        <Route path="locations" element={<AdminRoute><WorkLocationMaster /></AdminRoute>} />
        <Route path="admin/employee-master" element={<AdminRoute><AdminEmployeeMaster /></AdminRoute>} />
        <Route path="introduction" element={<AdminRoute><IntroductionSetup /></AdminRoute>} />
        <Route path="permissions/matrix" element={<AdminRoute><PermissionManager /></AdminRoute>} />
        <Route path="/admin/project-master" element={<AdminRoute><ProjectMasterCreate /></AdminRoute>} />
        <Route path="/admin/project-patterns" element={<AdminRoute><ProjectPatternViewer /></AdminRoute>} />
        <Route path="/admin/quotes" element={<AdminRoute><AdminQuotes /></AdminRoute>} />


        {/* 何にもマッチしない時 */}
        <Route path="*" element={<Placeholder title="OK: 404" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter basename={detectBase()}>
      <AppRoutes />
    </BrowserRouter>
  );
}
